export default __webpack_public_path__ + "static/spread-c954fcf9f856b959ed4275f83a0f404d.png";